module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_17_4.c8ba21c8.jpeg";